import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeveloperAutoComponent } from './developer-auto/developer-auto.component';

const routes: Routes = [
	{
		path: '', component: DeveloperAutoComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class DeveloperRoutingModule { }
